import { render, staticRenderFns } from "./WeDermaLogo.vue?vue&type=template&id=9a7128b2&scoped=true&"
import script from "./WeDermaLogo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WeDermaLogo.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7128b2",
  null
  
)

export default component.exports